import { Dashboard } from '@mui/icons-material'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import React from 'react'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import GenVehicleReport from './component/genVehicleReport'
import FilterOrg from '../OrgAmin/components/FilterOrg'
import MDBox from "components/MDBox";

function GenerateVehicleReport() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={4} display="flex" justifyContent="center">
        <FilterOrg />
      </MDBox>
      <GenVehicleReport />
    </DashboardLayout>
  )
}

export default GenerateVehicleReport
